import { catalog } from '../core/catalog.js';
import { filters } from '../core/filters.js';
import { countryName } from '../core/country.js';
import { i18n, t } from '../core/i18n.js';
import { openCategoryPicker } from './render.js';

/* Filtro por país de los listados (TV en directo, Películas, Series). El país sale del prefijo que
   el proveedor pone a los nombres (core/country.js). Solo aparece si el catálogo trae más de uno. */

const NONE = 'none';

export function createCountryFilter(section, kind, saved) {
    const state = { wanted: Array.isArray(saved && saved.countries) ? saved.countries.map(String) : [], active: [] };
    const label = (id) => (id === NONE ? t('country.none') : countryName(id, i18n.lang) + ' (' + id + ')');
    // De más a menos títulos, y lo que no trae país, al final.
    const available = () => (catalog.countries[kind] || []).slice().sort((a, b) => (a.id ? 0 : 1) - (b.id ? 0 : 1));

    return {
        /** Hay algo que elegir: al menos dos países, o uno y títulos sin país. */
        get shown() {
            const list = available();
            return list.length > 1 && list.some((c) => c.id);
        },

        /** Países elegidos que existen ahora mismo en el catálogo. */
        get active() {
            return state.active;
        },

        /** Recalcula lo elegido frente a lo que hay (el catálogo puede estar cargando un proveedor). */
        sync() {
            const ids = new Set(available().map((c) => c.id || NONE));
            state.active = this.shown ? state.wanted.filter((id) => ids.has(id)) : [];
            return state.active;
        },

        /** Entrada para la barra de filtros, o null si no hay países que elegir. */
        chip() {
            if (!this.shown) return null;
            const a = state.active;
            const value = a.length === 0 ? t('common.all') : a.length === 1 ? label(a[0]) : t('country.n', { n: a.length });
            return { key: 'country', icon: 'public', label: t('country.title'), value, active: a.length > 0 };
        },

        apply(items) {
            if (!state.active.length) return items;
            const set = new Set(state.active);
            return items.filter((it) => set.has(it.region || NONE));
        },

        /** De una lista de categorías, las que tienen algo de los países elegidos. */
        categories(cats) {
            if (!state.active.length) return cats;
            const set = new Set(state.active);
            return cats.filter((c) => {
                const own = catalog.categoryCountries(kind, c.id);
                return own.some((id) => set.has(id || NONE));
            });
        },

        open(onChange) {
            const list = [{ id: 'all', name: t('common.all'), icon: 'public' }].concat(available().map((c) => ({ id: c.id || NONE, name: label(c.id || NONE), count: c.count, icon: c.id ? 'flag' : 'help_outline' })));
            openCategoryPicker({
                title: t('country.title'),
                list,
                active: state.active,
                multi: true,
                onSelect: (picked) => {
                    state.wanted = Array.isArray(picked) ? picked.map(String) : [];
                    filters.set(section, { countries: state.wanted });
                    this.sync();
                    onChange();
                }
            });
        }
    };
}
